import { z } from 'zod/v4';
import { CountryCode } from '../../index.js';
export var VoucherTypeIds;
(function (VoucherTypeIds) {
    VoucherTypeIds["PRINCIPAL"] = "1738f635-561f-4bf4-b7be-3a63597ea429";
    VoucherTypeIds["INVOICE"] = "eb41e58e-fccf-419d-a771-cd5027fe6e87";
    VoucherTypeIds["ONACCOUNTINVOICE"] = "2d101b6e-74f9-4a4d-9f8e-c7abe2264da0";
    VoucherTypeIds["FINALINVOICE"] = "42385ae0-6846-425c-a793-8d47a3b190b5";
    VoucherTypeIds["CREDITNOTE"] = "ef2cdc50-230f-4046-b1af-0f9c498dddd3";
    VoucherTypeIds["DOM"] = "6c0ce89b-ec2b-46fd-a555-55e5b4228154";
    VoucherTypeIds["GAELDSBREV"] = "bf61f462-6d3c-42e8-a99a-852d4a664926";
    VoucherTypeIds["YEARLYINTEREST"] = "37db68dd-80be-40c7-8d2d-3619c793107f";
    VoucherTypeIds["PROCESSINTEREST"] = "ca4af363-9925-436c-83d6-23b3db6ed5d2";
    VoucherTypeIds["GLPROCESSINTEREST"] = "4080e9fa-3e76-48f6-b892-4095036a85e8";
    VoucherTypeIds["COMPOUNDINTEREST_DAILY_CAP"] = "b197c733-9fc0-47ce-987d-97298bce6e0a";
    VoucherTypeIds["COMPOUNDINTEREST_MONTHLY_CAP"] = "f0bb73e3-1723-481e-97a1-5dca722c16fe";
    VoucherTypeIds["COMPOUNDINTEREST_QUARTERLY_CAP"] = "0ea6fc41-466f-42d9-9ca7-8223ac3ec189";
    VoucherTypeIds["REMINDERFEE"] = "3e51bf87-3c8f-4dd5-abd5-69417d113c89";
    VoucherTypeIds["COLLECTIONCOST"] = "07960de4-303d-4793-92da-3a8cfd5da1a1";
    VoucherTypeIds["COLLECTIONFEE"] = "4c3ccbbf-0651-45b2-b37b-4fe736acfd7e";
    VoucherTypeIds["COMPENSATIONCOST"] = "ed3e3d61-e1bc-4ee2-9166-adf2c41a2bbf";
    VoucherTypeIds["Folkeregisteropslag"] = "20cfe471-fa7d-426f-9b16-95e2505d2f8b";
    VoucherTypeIds["POLICEPRESENTATIONFEE"] = "bdb1019c-a7b7-44ef-b94a-7f369b8f6445";
    VoucherTypeIds["WRITSALARY"] = "bba18e06-4cff-42a6-a3fe-35fc2d955c62";
    VoucherTypeIds["BAILIFFSFEE"] = "15c122ef-95b7-4c2f-abca-73251ea7af36";
    VoucherTypeIds["FOGEDREKVISITIONSFEE"] = "ed3b8fbb-5348-4a28-9844-e680a4ac568a";
    VoucherTypeIds["WRITFEE"] = "0cfddbe2-d771-4597-a14c-4b8054a5df09";
    VoucherTypeIds["MeetingFee"] = "3f5bd7be-9ecd-4e0c-87d1-4a1c04287404";
    VoucherTypeIds["BAILIFSSALARY"] = "3e05c40a-f97d-4518-ae10-ca3743642e0f";
    VoucherTypeIds["COURTCLAIMCOSTWITHOUTCIVILCOURT"] = "f5773796-b267-4767-b4a8-50cfcac78789";
    VoucherTypeIds["COURTCLAIMSALARY"] = "7bea8d18-f57f-4ce1-8e1e-5ab6f4779d39";
    VoucherTypeIds["COURTCLAIMCOSTWITHBAILIFFSCOURT"] = "bec48a87-140f-4a7f-88dc-f4563e53da98";
    VoucherTypeIds["IMMATERIALRETLIGESAGER"] = "d052cf1d-4d85-4bfe-b735-8d8a14ea214e";
    VoucherTypeIds["CIVILCOURTCOST"] = "426778b7-7d35-48a0-bfd8-2f3b111053ad";
    VoucherTypeIds["DEPOSIT"] = "c51f2f6a-8081-45ef-b52d-5e0569fdf12e";
    VoucherTypeIds["WITHDRAWAL"] = "11a8c26e-fe31-4092-adf5-431dc96e8a27";
    VoucherTypeIds["REFUND"] = "0f45d7c5-51f8-4632-885e-c127c130598e";
    VoucherTypeIds["OVERPAYMENT"] = "fec87dd5-710d-479c-9bf0-15feae6566ca";
    VoucherTypeIds["COLLECTIONCOMMISSION"] = "a3850e09-9e2a-4bc9-a557-c9465e6e1b76";
    VoucherTypeIds["COLLECTIONCOMMISSIONSURVEILLANCE"] = "8f4745b0-6347-4fec-9ac8-ffad584395c9";
    VoucherTypeIds["COLLECTIONCOMMISSIONCLIENTDEPOSIT"] = "d67b581e-e21b-4ebc-911d-233d95b39265";
    VoucherTypeIds["DEPOSITPAYOUT"] = "46c7d904-8fc7-4649-a988-1faf54fa3fb9";
    VoucherTypeIds["JURIDISKBISTAND"] = "a791f938-190c-4239-a07c-c4cb245a406b";
    VoucherTypeIds["ENDCASEFEE"] = "0527b2dc-be71-4393-b80d-3699512dcc39";
    VoucherTypeIds["STARTCASEFEE"] = "d21c92ae-48fa-423f-8ee1-7d9b2d240e34";
    VoucherTypeIds["BPKFEE"] = "2e096de3-851e-4056-aff5-cc2e24e6b8f9";
    VoucherTypeIds["RKIREGISTRATIONFEE"] = "98b7a66a-dee9-4330-8b41-09a643294e21";
    VoucherTypeIds["BPKDISBURSEMENT"] = "aa49a4b2-422d-4128-b76d-eba04d6349d1";
    VoucherTypeIds["POLICEDISBURSEMENT"] = "5bc70182-7bd4-43cb-ac10-c62db0333d18";
    VoucherTypeIds["FOGEDFEE"] = "9ef583f0-6c85-4047-8d4f-480c4b6ee87c";
    VoucherTypeIds["FOGEDDISBURSEMENT"] = "afd4c17b-8080-41df-ab96-bf458ec4367c";
    VoucherTypeIds["VAT"] = "886b6c92-f1ac-48a4-b4a5-fc95052261a7";
    VoucherTypeIds["SETTLEMENT"] = "0c0229ad-083b-4007-ac2d-ff2596875f42";
    VoucherTypeIds["FIXEDINTEREST"] = "299dc393-1b71-4950-860f-8fb485036722";
    VoucherTypeIds["UDTRAEKSGEBYR"] = "8c70a4b1-999a-40b4-b945-4be229de2fb4";
    VoucherTypeIds["FOLKEREGISTEROPSLAG"] = "ee78dab8-b3d2-4108-8568-b813bea34040";
    VoucherTypeIds["ANMELDELSEAFKRAV"] = "9e210917-7e21-4076-a422-8151d6908603";
    VoucherTypeIds["STAEVNINGSGEBYR"] = "6991fa7e-5812-4948-be69-0001d1f7205f";
    VoucherTypeIds["BERAMMELSESAFGIFT"] = "bf3a02e9-f4ea-4b6f-a8fd-722531ab30cd";
    VoucherTypeIds["CONTROLFEE"] = "7142ebfc-2554-4433-b195-c2e02d007c84";
    VoucherTypeIds["ADMINISTRATIONCOST"] = "99814460-89a2-4c91-bc43-875f9d2b3d2d";
    VoucherTypeIds["LOCKSMITHFEE"] = "bba2b51e-0770-4df6-af32-a467f1c5eca5";
    VoucherTypeIds["DRIVINGFEE"] = "71f46d3d-4b05-4760-a0c8-323154a59b4e";
    VoucherTypeIds["AFLYSNINGAFUDLAEG"] = "4b464357-063e-4e4b-9142-7b3568393f09";
    VoucherTypeIds["OTHERFEE"] = "cecc0af5-b5c4-4adc-99c8-14bbe07331d5";
})(VoucherTypeIds || (VoucherTypeIds = {}));
export var VoucherCategory;
(function (VoucherCategory) {
    VoucherCategory["DISBURSEMENT"] = "disbursement";
    VoucherCategory["FEE"] = "fee";
    VoucherCategory["COLLECTIONCOMMISSION"] = "collectioncommission";
    VoucherCategory["PAYOUT"] = "payout";
    VoucherCategory["OVERPAYMENT"] = "overpayment";
    VoucherCategory["VAT"] = "vat";
    VoucherCategory["TRANSACTION"] = "transaction";
    VoucherCategory["COST"] = "cost";
    VoucherCategory["COURTCOST"] = "courtcost";
    VoucherCategory["INTEREST"] = "interest";
    VoucherCategory["PRINCIPAL"] = "principal";
})(VoucherCategory || (VoucherCategory = {}));
export var VoucherTypeSetting;
(function (VoucherTypeSetting) {
    VoucherTypeSetting["YearlyInterest"] = "YEARLY_INTEREST";
    VoucherTypeSetting["InterestFromTable"] = "INTEREST_FROM_TABLE";
    VoucherTypeSetting["CompoundInterest"] = "COMPOUND_INTEREST";
    VoucherTypeSetting["FixedInterest"] = "FIXED_INTEREST";
    VoucherTypeSetting["AmountFromTable"] = "AMOUNT_FROM_TABLE";
    VoucherTypeSetting["TextAsLabel"] = "TEXT_AS_LABEL";
})(VoucherTypeSetting || (VoucherTypeSetting = {}));
export var CompoundingPeriod;
(function (CompoundingPeriod) {
    CompoundingPeriod["Daily"] = "DAILY";
    CompoundingPeriod["Monthly"] = "MONTHLY";
    CompoundingPeriod["Quarterly"] = "QUARTERLY";
})(CompoundingPeriod || (CompoundingPeriod = {}));
export var ImposeInterestFrequency;
(function (ImposeInterestFrequency) {
    ImposeInterestFrequency["Daily"] = "DAILY";
})(ImposeInterestFrequency || (ImposeInterestFrequency = {}));
export var DayCountConvention;
(function (DayCountConvention) {
    DayCountConvention["ThreeSixFive"] = "365";
    DayCountConvention["ThreeSixZero"] = "360";
})(DayCountConvention || (DayCountConvention = {}));
export const daysAYear = (caseVoucher) => {
    if (caseVoucher.setting === VoucherTypeSetting.CompoundInterest ||
        caseVoucher.setting === VoucherTypeSetting.InterestFromTable ||
        caseVoucher.setting === VoucherTypeSetting.YearlyInterest) {
        switch (caseVoucher.settingDetails.dayCountConvention) {
            case DayCountConvention.ThreeSixFive:
                return 365;
            case DayCountConvention.ThreeSixZero:
                return 360;
            default:
                break;
        }
    }
    throw new Error('Day count convention not handled');
};
export var ExpirationPeriods;
(function (ExpirationPeriods) {
    ExpirationPeriods[ExpirationPeriods["TEN_YEARS"] = 10] = "TEN_YEARS";
    ExpirationPeriods[ExpirationPeriods["THREE_YEARS"] = 3] = "THREE_YEARS";
})(ExpirationPeriods || (ExpirationPeriods = {}));
export const VouchersHumanized = {
    [VoucherTypeIds.DEPOSIT]: ['Indbetaling'],
    [VoucherTypeIds.DEPOSITPAYOUT]: ['Udbetaling af indbetaling'],
    [VoucherTypeIds.ONACCOUNTINVOICE]: ['Acontofaktura'],
    [VoucherTypeIds.DOM]: ['Dom'],
    [VoucherTypeIds.FINALINVOICE]: ['Endelig opgørelse'],
    [VoucherTypeIds.GAELDSBREV]: ['Gældsbrev'],
    [VoucherTypeIds.SETTLEMENT]: ['Frivilligt forlig'],
    [VoucherTypeIds.INVOICE]: ['Faktura'],
    [VoucherTypeIds.CREDITNOTE]: ['Kreditnota'],
    [VoucherTypeIds.IMMATERIALRETLIGESAGER]: ['Immaterialretlig krænkelse'],
    [VoucherTypeIds.CONTROLFEE]: ['Kontrolafgift'],
    [VoucherTypeIds.ADMINISTRATIONCOST]: ['Administrationsgebyr'],
    [VoucherTypeIds.GLPROCESSINTEREST]: ['Procesrente (GL)'],
    [VoucherTypeIds.PROCESSINTEREST]: ['Procesrente'],
    [VoucherTypeIds.YEARLYINTEREST]: ['Årlig rente'],
    [VoucherTypeIds.FIXEDINTEREST]: ['Fast rente'],
    [VoucherTypeIds.REMINDERFEE]: ['Rykkergebyr'],
    [VoucherTypeIds.COLLECTIONCOST]: ['Inkassoomkostninger'],
    [VoucherTypeIds.COLLECTIONFEE]: ['Inkassogebyr'],
    [VoucherTypeIds.COMPENSATIONCOST]: ['Kompensationsgebyr'],
    [VoucherTypeIds.UDTRAEKSGEBYR]: ['Udtræksgebyr'],
    [VoucherTypeIds.OTHERFEE]: ['Anden omkostning'],
    [VoucherTypeIds.Folkeregisteropslag]: ['Folkeregisteropslag'],
    [VoucherTypeIds.MeetingFee]: ['Mødesalær'],
    [VoucherTypeIds.BAILIFSSALARY]: ['Sagsomkostninger'],
    [VoucherTypeIds.POLICEPRESENTATIONFEE]: ['Politifremstillingsgebyr'],
    [VoucherTypeIds.WRITFEE]: ['Stævningsgebyr'],
    [VoucherTypeIds.BAILIFFSFEE]: ['Betalingspåkravsgebyr'],
    [VoucherTypeIds.FOGEDREKVISITIONSFEE]: ['Fogedrekvisitionsgebyr'],
};
const YearlyInterestVoucherTypeSettingSchema = z.object({
    dayCountConvention: z.enum(DayCountConvention),
    imposeInterestFrequency: z.enum(ImposeInterestFrequency),
});
const TextAsLabelVoucherTypeSettingSchema = z.object({});
const InterestFromTableVoucherTypeSettingSchema = z.object({
    dayCountConvention: z.enum(DayCountConvention),
    imposeInterestFrequency: z.enum(ImposeInterestFrequency),
    interestRates: z.array(z.object({
        date: z.iso.datetime({ offset: true }),
        rate: z.number(),
        time: z.number().int(),
    })),
});
const CompoundInterestVoucherTypeSettingSchema = z.object({
    dayCountConvention: z.enum(DayCountConvention),
    imposeInterestFrequency: z.enum(ImposeInterestFrequency),
    compoundingPeriod: z.enum(CompoundingPeriod),
});
const FixedInterestVoucherTypeSettingSchema = z.object({});
const AmountFromTableVoucherTypeSettingSchema = z.object({});
export const CreateVoucherTypeSchema = z.intersection(z.object({
    label: z.string(),
    category: z.enum(VoucherCategory),
    order: z.number().int(),
    country: z.enum(CountryCode).optional(),
    vat: z.boolean().optional(),
}), z.union([
    z.object({
        setting: z.literal(VoucherTypeSetting.AmountFromTable),
        settingDetails: AmountFromTableVoucherTypeSettingSchema,
    }),
    z.object({
        setting: z.literal(VoucherTypeSetting.CompoundInterest),
        settingDetails: CompoundInterestVoucherTypeSettingSchema,
    }),
    z.object({
        setting: z.literal(VoucherTypeSetting.FixedInterest),
        settingDetails: FixedInterestVoucherTypeSettingSchema,
    }),
    z.object({
        setting: z.literal(VoucherTypeSetting.InterestFromTable),
        settingDetails: InterestFromTableVoucherTypeSettingSchema,
    }),
    z.object({
        setting: z.literal(VoucherTypeSetting.YearlyInterest),
        settingDetails: YearlyInterestVoucherTypeSettingSchema,
    }),
    z.object({
        setting: z.literal(VoucherTypeSetting.TextAsLabel),
        settingDetails: TextAsLabelVoucherTypeSettingSchema,
    }),
    z.object({
        setting: z.null(),
        settingDetails: z.null(),
    }),
]));
export const EditorSettingsSchema = z.object({
    sourceInput: z.boolean().optional(),
    defaultSource: z.string().optional(),
    dueDateInput: z.boolean().optional(),
    dueDateRequired: z.boolean().optional(),
    defaultAmount: z.number().optional(),
    amountNegative: z.boolean().optional(),
    referenceCaseVoucherInput: z.boolean().optional(),
    referenceCaseVoucherRequired: z.boolean().optional(),
    addInterest: z.boolean().optional(),
    referenceIdInput: z.boolean().optional(),
    referenceIdRequired: z.boolean().optional(),
    textInput: z.boolean().optional(),
    appendixInput: z.boolean().optional(),
    appendixRequired: z.boolean().optional(),
    hideProperties: z.boolean().optional(),
    showOnCreditorWeb: z.boolean().optional(),
});
export const PatchVoucherTypeSchema = z.object({
    label: z.string().optional(),
    editorSettings: EditorSettingsSchema.optional(),
});
export const ErrorYouAreAboutToMakePossibleUnintendedAdjustments = 'You are about to adjust already billed deposits.';
//# sourceMappingURL=index.js.map